import axios from 'axios'
import { decode } from 'jsog/lib/JSOG'

const toData = response => decode(response.data)

export function get(screenElementId): Promise {
  return axios.get(`/bw/static/tooltip/${screenElementId}`).then(toData)
}



// WEBPACK FOOTER //
// ./src/services/tooltip-service.js